import { render, staticRenderFns } from "./activityShow.vue?vue&type=template&id=07095f3a&scoped=true"
import script from "./activityShow.vue?vue&type=script&lang=js"
export * from "./activityShow.vue?vue&type=script&lang=js"
import style0 from "./activityShow.vue?vue&type=style&index=0&id=07095f3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07095f3a",
  null
  
)

export default component.exports